module.exports = __webpack_public_path__ + "static/img/create_other.cf40796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/create_other.png
// module id = 6r1O
// module chunks = 3